module.exports = __webpack_public_path__ + "static/media/iStock-478272220.86a8a97b.gif";